// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { MFAFactor } from "../../../Utilities";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the createdAt field of the MFAFactor model.
 */
export function createdAt(value: MFAFactor["createdAt"] | null): string {
	return Models.toString(value);
}

/**
 * Formats the count field of the MFAFactor model.
 */
export function count(value: MFAFactor["count"] | null): string {
	return Models.toString(value);
}

/**
 * Formats the isApp field of the MFAFactor model.
 */
export function isApp(value: MFAFactor["isApp"]): string {
	return Models.toString(value);
}

/**
 * Formats the email field of the MFAFactor model.
 */
export function email(value: MFAFactor["email"]): string {
	return Models.toString(value);
}

/**
 * Formats the sms field of the MFAFactor model.
 */
export function sms(value: MFAFactor["sms"]): string {
	return Models.toString(value);
}

/**
 * Formats the isVerified field of the MFAFactor model.
 */
export function isVerified(value: MFAFactor["isVerified"]): string {
	return Models.toString(value);
}
